import React, { FunctionComponent, memo, useContext, useEffect, useMemo } from 'react'
import { musicContext } from '@hoc/WithMusic'
import { useTranslation } from 'react-i18next'
import Select from '@components/Select/Select'
import { SurveyContext } from '@context/SurveyContext'
import { AlbumEntry } from '@models/Music'

interface GenreInputProps {}

const GenreInput: FunctionComponent<GenreInputProps> = () => {
  const { t } = useTranslation('Music')
  const { selectGenre, selectedGenre, genres, selectedAlbum } = useContext(musicContext)
  const { currentAnswer } = useContext(SurveyContext)

  useEffect(() => {
    if (currentAnswer) {
      selectGenre((currentAnswer as AlbumEntry)?.genre)
    }
  }, [])

  useEffect(() => {
    selectGenre(selectedAlbum?.genre)
  }, [selectedAlbum])

  const items = useMemo(() => genres.map((genre) => ({ value: genre, label: t(genre) })), [genres])

  return (
    <Select
      value={selectedGenre}
      items={items}
      placeholder={t('genre')}
      onChange={(item) => {
        if (item) {
          selectGenre(item.value)
        }
      }}
    />
  )
}

export default memo(GenreInput)
